import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cc75d99"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banners" }
const _hoisted_2 = { class: "banners--title flex-center-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "leksa_title fz22" }, "Баннеры", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Добавить", -1))
const _hoisted_5 = { class: "banners--container flex wrap-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_plus_icon = _resolveComponent("plus-icon")!
  const _component_common_button = _resolveComponent("common-button")!
  const _component_common_banner = _resolveComponent("common-banner")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_common_button, {
        class: "btn--small",
        onClickButton: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modal('admin-banner')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_plus_icon),
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banners, (banner) => {
        return (_openBlock(), _createBlock(_component_common_banner, {
          key: banner._id,
          banner: banner
        }, null, 8, ["banner"]))
      }), 128))
    ])
  ]))
}